export default "__VITE_ASSET__BxpqR$cB__"